module.exports = __webpack_public_path__ + "img/615a93b418506.ce9b0098.jpg";